var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"card"},[_c('div',{staticClass:"card-body"},[_c('h4',{staticClass:"card-title mb-4"},[_vm._v(_vm._s(_vm.translate("most-watched"))+" "+_vm._s(_vm.title))]),_c('apexchart',{staticClass:"apex-charts",attrs:{"height":"350","type":"bar","dir":"ltr","series":_vm.chart.series,"options":_vm.chart.chartOptions}})],1)])
}
var staticRenderFns = []

export { render, staticRenderFns }